<template>
  <div class="person-document">
    <el-row>
      <el-col>
        <div class="person-document__tips">
          <i class="el-icon-warning"></i>
          <span class="person-document__tips_text">此处预览仅展示当前登录者的信息</span>
        </div>
        <div class="person-document__tips_two">
          <span>如需要修改，请登录移动端进行修改，个人信息、联系方式及个人简介由员工个人进行配置。</span>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'PersonDocument'
}
</script>

<style lang="scss" scoped>
.person-document {
  margin: 10px 30px 30px;
  padding: 8px 10px;
  font-size: 14px;
  border: 1px solid #ffd591;
  background-color: #fff7e6;
  border-radius: 4px;
}

.person-document__tips {
  .el-icon-warning {
    margin-right: 8px;
    color: #fa8c15;
    font-size: 16px;
  }
}

.person-document__tips_two {
  color: #8c8c8c;
  margin-left: 24px;
}
</style>
